import { render, staticRenderFns } from "./OrgReports.vue?vue&type=template&id=5e3a667a&"
import script from "./OrgReports.vue?vue&type=script&lang=js&"
export * from "./OrgReports.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports